import { ButtonVariant } from '@vimily/bonjoro-ui-components-v2';
import { Button } from '@vimily/bonjoro-ui-components-v2/Button';
import React from 'react';
import cx from 'classnames';
import { startUpgradeModalFlow } from '../Modals/UpgradeModalFlow';
import { UpgradeModalTrigger } from '../Modals/UpgradeModalFlow/util';

export enum UpgradeRefType {
  GreetLimitReachedAlert = 'greet-limit-reached-alert',
  GreetLimitWarningAlert = 'greet-limit-warning-alert',
}

export enum ButtonType {
  Link = 'link',
  ModalButton = 'modal-button',
}

export interface VideoLimitAlertUpgradeButtonProps {
  buttonType: ButtonType;
  upgradeRefType: UpgradeRefType;
  className?: string;
}

const VideoLimitAlertUpgradeButton = ({
  buttonType,
  className,
}: VideoLimitAlertUpgradeButtonProps) => {
  const onClick = () => {
    startUpgradeModalFlow({
      trigger: UpgradeModalTrigger.UpgradeButton,
      reason: 'User hit the video limit',
    });
  };

  if (buttonType === ButtonType.Link) {
    return (
      <a href='#' onClick={onClick} className={className}>
        Send more videos now and unlock Pro features today
      </a>
    );
  } else if (buttonType === ButtonType.ModalButton) {
    return (
      <Button
        variant={ButtonVariant.Icon}
        onClick={onClick}
        className={cx('!p-0', className)}
      >
        Get the full Bonjoro experience!
      </Button>
    );
  }

  return null;
};

export default VideoLimitAlertUpgradeButton;
